<template>
    <div class="Item_bundle_product">
        <div class="box-button-details">
        <div @click="ShowDetailsProduct" class="Item_bundle_product_image">
            <img width="100%" :src="image" />
        </div>
        <button class="btn-button-details" @click="ShowDetailsProduct">See details</button>
        <modal
            :name="modalName"
            :adaptive="true"
            height="auto"
            width="1200"
            @cancel="handleCancel"
            :clickToClose="true"
            :reset="true"
            class="modal_details"
        >
            <div class="box-button-close-mockups">
                <button @click="handleCancel" class="button-close-mockups">&#10005;</button>
            </div>
            <div class="PrintArea-box">
                <form>
                <div class="box-mockup">
                    <div class="box-mockup_item box-mockup_item1">
                        <mockup-product
                            :mockups="mockups[0]"
                            :artworks="artworks"
                            :originProduct="originProduct"
                            :layers="layers"
                            :personalized="personalized"
                            :modalName="modalName"
                        />
                    </div>
                    <div class="box-mockup_item box-mockup_item2">
                        <form-bundled
                        :originProduct="originProduct"
                        :platform="platform"
                        :variants="variants"
                        :personalized="personalized"
                        :permalink="permalink"
                        :artworks="artworks"
                        @onOK="onOK"
                        @OnCloseAddToCart="OnCloseAddToCart"
                        />
                    </div>
                </div>
                </form>
            </div>

        </modal>


        <div class="box-messenge-add-to-cart" v-bind:class="{success: addSuccess, error: addError}" v-if="messageStatus">
                {{message}}
        </div>
    </div>
    </div>
</template>

<script>
import MockupProduct from './MockupBundled/MockupProduct';

import { Carousel, Slide } from 'vue-carousel'
import FormBundled from './FormBundled/FormBundled';
export default {
  components: { MockupProduct, Carousel, Slide, FormBundled },
    name: "ProductDetails",
    props: {
      artworks: {
          type: Array,
          default(){
              return null
          }
      },
      mockups: {
          type: Array,
          default(){
              return null
          }
      },
      originProduct: {
          type: Object,
          default(){
              return null
          }
      },
      personalized: {
          type: Object,
          default(){
              return null
          }
      },
      platform: {
          type: String,
          default(){
              return null
          }
      },
      variants: {
          type: Array,
          default(){
              return {}
          }
      },
      permalink: {
          type: String,
          default(){
              return ''
          }
      }
    },
    data(){
        return {
            stageSize: {
                width: 1000,
                height: 1000,
                layers: []
            },
            layers: {},
            personalizedRender: {},
            message: "Product added to cart successfully!",
            messageStatus: false,
            addSuccess: true,
            addError: false,
            image: '',
        }
    },
    computed: {
        modalName() {
           return `product-${this.uniqueID(10)}`
        },

    },
    created(){
        const artworks = this.artworks;
        this.layers = artworks[0].templates[0].layers
        // this.stageSize.width = artworks[0].width;
        // this.stageSize.height = artworks[0].height;
        if(this.platform == "woocommerce"){
            this.image = this.originProduct.images[0]['src'];
        }if(this.platform == "shopify"){
            this.image = this.originProduct.product.image.src;
        }
        
    },
    methods: {
        uniqueID(length) {
            var result = ''
            var chars =
                '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
            for (var i = length; i > 0; --i)
                result += chars[Math.floor(Math.random() * chars.length)]
            return result
        },
        ShowDetailsProduct(e){
            e.preventDefault()
            this.$modal.show(this.modalName);

            const personalizedStore = this.$store.state.personalized[this.$store.state.artworks[0].id];
            const bundledpersonalizedStore = this.personalized[this.artworks[0].id]
            // console.log(bundledpersonalizedStore)
            // console.log(personalizedStore)
            for(var a in personalizedStore){
                for(var b in bundledpersonalizedStore){
                    if(a == b){
                        bundledpersonalizedStore[b] = personalizedStore[a]
                    }
                }

            }
        },
        handleCancel(e) {
            e.preventDefault()
            this.$modal.hide(this.modalName)
        },
        onOK(v){
            if(v){
                this.$modal.hide(this.modalName)
                this.message = "Product added to cart successfully!"
                this.messageStatus = true
                this.addSuccess = true
                const OnThis = this
                setTimeout(()=>{
                    OnThis.messageStatus = false
                }, 3000)

            }
        },
        OnCloseAddToCart(v){
            this.$modal.hide(this.modalName)
        }
    }
}
</script>



<style scoped>
    button.btn-button-details {
        position: absolute;
        bottom: -1px;
        left: 5px;
        right: 5px;
    }

    .Item_bundle_product_image{
        cursor: pointer;
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .Item_bundle_product_image > *{
        position: absolute;
    }

    .Item_bundle_product_image:after {
        content: "";
        display: block;
        padding-bottom: 100%;
    }
    .box-mockup{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .box-mockup_item1{
        position: relative;
    }
    .box-mockup_item{
        width: 50%;
    }
    .box-button-close-mockups{
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 999999;
    }
    .button-close-mockups{
        background: #f1f1f2;
        border: none;
        font-size: 17px!important;
        width: 40px !important;
        height: 40px !important;
        border-radius: 50%!important;
        color: #949494;
        -webkit-transition: .5s;
        transition: .5s;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 !important;
        margin: 0 !important;
        line-height: 0px !important;
        overflow: hidden !important;
    }
    .button-close-mockups:hover{
        color: #ffffff;
        background: #6c757d;
    }
    .btn-button-details{
        margin: 0 auto;
        border: none;
        background: #ffffffc7;
        color: #2e2e2e;
        padding: 2px 10px;
        font-size: 15px;
        font-weight: 600;
        transition: transform 300ms ease-out;
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
      text-transform: capitalize;
    }

    /* dsn */

    .Item_bundle_product:hover .btn-button-details{
        background: #3bbf31;
        color: #ffffff;
    }

    .box-button-details:hover .btn-button-details{
        background: #3bbf31;
        color: #ffffff;
    }

    .box-messenge-add-to-cart{
        position: fixed;
        top: 5px;
        right: 5px;
        padding: 9px 19px;
        border-radius: 5px;
        font-weight: 600;
    }

    .success{
        color: #ffffff;
        background: #3bbf31;
    }

    .error{
        color: #ffffff;
        background: #ff5050;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {



    }

    @media (max-width: 767px) {

    .box-mockup {
        display: flex;
        flex-direction: column;
    }

    .box-mockup_item {
        width: 100%;
    }

    .optionsBox {
        width: 45%;
        margin: 5px;
    }
    .optionsBox > label{
        font-size: 14px;
    }

    h2.product-title.product_title{
        font-size: 21px;
    }

    .btn-button-details{
        font-size: 15px;
    }

    }
</style>

<style>
.modal_details .vm--modal{
    position: relative;
    padding: 20px;
}

@media (max-width: 767px) {

   .modal_details .vm--modal{
       padding: 0px ;
       overflow: auto;
       top: 0 !important;
        bottom: 0 !important;
        height: 100vh !important;
   }

}
</style>



// WEBPACK FOOTER //
// src/components/BundledProduct/ProductDetails.vue